/* Release 5 Line-up (hardware category pages). 1 tile = in-page filter (facets.js) · 2 tiles track every filter path · 3 desktop
   sidebar not modal · 4 in-grid shelf + sticky offset · 5 "Sort" label · 6 active-filter row · 7 scroll to results after a user filter. */
(function () {
  var root = document.querySelector('[data-lu]');
  if (!root || root.__lu) return;
  root.__lu = 1;
  var key = root.getAttribute('data-lu-key') || '';
  var nav = root.querySelector('.lu-tiles');
  var tiles = nav ? [].slice.call(nav.querySelectorAll('.lu-tile')) : [];
  var reduced = matchMedia('(prefers-reduced-motion: reduce)');
  var phone = matchMedia('(max-width: 767px)');
  var desk = matchMedia('(min-width: 1025px)');
  var wrap = document.querySelector('.tps-lu');

  function sp(s) { try { return new URLSearchParams(s == null ? location.search : String(s)); } catch (e) { return new URLSearchParams(''); } }
  function reveal(t) {
    if (!t || !nav || nav.scrollWidth <= nav.clientWidth) return;
    var n = nav.getBoundingClientRect(), r = t.getBoundingClientRect();
    if (r.left >= n.left && r.right <= n.right) return;
    var x = nav.scrollLeft + r.left - n.left - 20;
    try { nav.scrollTo({ left: Math.max(0, x), behavior: reduced.matches ? 'auto' : 'smooth' }); } catch (e) { nav.scrollLeft = Math.max(0, x); }
  }
  function sync(p) {
    if (!key) return null;
    var vals = p.getAll(key), cur = null;
    tiles.forEach(function (t) {
      var v = t.getAttribute('data-lu-v');
      var on = v ? (vals.length === 1 && vals[0] === v) : vals.length === 0;
      if (on) { t.setAttribute('aria-current', 'true'); cur = t; } else t.removeAttribute('aria-current');
    });
    return cur;
  }
  function facets() {
    var C = window.customElements && customElements.get('facet-filters-form');
    return C && typeof C.renderPage === 'function' && document.getElementById('ProductGridContainer') ? C : null;
  }

  /* 1 */
  if (nav) nav.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.lu-tile');
    if (!a || !key || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var C = facets();
    if (!C) return;
    e.preventDefault();
    want();
    var p = sp();
    p.delete(key); p.delete('page');
    var v = a.getAttribute('data-lu-v');
    if (v) p.append(key, v);
    C.renderPage(p.toString(), null, true);
    reveal(sync(p));
  });

  /* 2: tiles track every filter path. 7: a USER filter change ends with the scroll to the results.
     ROOT FIX A-B-02 (19 Oct): the scroll used to ride on a wrapper around facets.js renderProductGridContainer, which runs
     loadMore / colorSwatches / tpwLoadMoreProgressUpdate after swapping the grid; if anything there threw (or another path
     rendered), the grid showed filtered and the scroll never fired. Now: INTENT is recorded on the user action (capture
     phase, before facets.js sees it) and COMPLETION is read from the DOM itself (the grid's .collection losing "loading",
     which facets.js sets in the same tick as the swap). Back/Forward clear the intent first, so they never scroll. */
  var intent = 0;
  function want() { intent = Date.now(); begin(); }
  var ACT = '.lu-tile,.tps-lu .tpw-gridchips a,.tps-lu facet-remove a,.tps-lu .js-facet-remove,.tps-lu .facet-sort-select__option';
  document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest(ACT); if (a && !e.button && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) want(); }, true);
  document.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('.tps-lu .facet-sort-select__option')) want(); }, true);
  ['change', 'input'].forEach(function (n) { document.addEventListener(n, function (e) { if (e.isTrusted && e.target.closest && e.target.closest('.tps-lu') && e.target.closest('#TpwIndexPanel,facet-filters-form,.tpw-gridhead,.facet-sort-select')) want(); }, true); });   /* filter forms only: a card or kit control never scrolls the page */
  window.addEventListener('popstate', function () { intent = 0; if (job) end(); sync(sp()); }, true);
  if (window.customElements) customElements.whenDefined('facet-filters-form').then(function (C) {
    if (!C || C.renderPage.__lu) return;
    var orig = C.renderPage;
    C.renderPage = function (s) { var r = orig.apply(this, arguments); try { sync(sp(s)); } catch (e) {} return r; };
    C.renderPage.__lu = 1;
  });
  var gridBox = document.getElementById('ProductGridContainer');
  if (gridBox) new MutationObserver(function (ms) {
    if (!intent) return;
    if (Date.now() - intent > 60000) { intent = 0; return; }
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i], el = m.target;
      if (m.attributeName === 'class' && el.classList && el.classList.contains('collection') && /\bloading\b/.test(m.oldValue || '') && !el.classList.contains('loading')) { intent = 0; if (job) { job.rendered = true; finish(); } return; }
    }
  }).observe(gridBox, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  reveal(nav && nav.querySelector('[aria-current]'));

  /* R5 polish: Brand "+N more" toggle (snippets/facets.liquid prints it; the panel re-render resets it, closed) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.tps-lu .lu-more-b');
    if (!b) return;
    var ul = b.closest('ul'); if (!ul) return;
    var on = !ul.classList.contains('lu-open');
    ul.classList.toggle('lu-open', on);
    b.setAttribute('aria-expanded', on ? 'true' : 'false');
    b.textContent = on ? 'Show fewer' : '+' + b.getAttribute('data-n') + ' more';
  });

  /* R5 crumb note: a tap on a product in this grid tells the PDP which collection it came from (pdpv9 reads it once) */
  var h1 = root.querySelector('.lu-h1');
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#ProductGridContainer a[href*="/products/"]');
    if (!a || !h1) return;
    try { var u = new URL(a.href, location.href); sessionStorage.setItem('tps-crumb', JSON.stringify({ p: u.pathname.replace(/^\/collections\/[^/]+/, ''), l: h1.textContent.trim(), u: location.pathname, t: Date.now() })); } catch (x) {}
  }, true);

  /* 3 */
  var rail = document.getElementById('TpwIndexPanel');
  if (rail && wrap) {
    var side = function () {
      if (desk.matches) { rail.removeAttribute('role'); rail.removeAttribute('aria-modal'); rail.removeAttribute('inert'); }
      else { rail.setAttribute('role', 'dialog'); rail.setAttribute('aria-modal', 'true'); if (!rail.classList.contains('is-open')) rail.setAttribute('inert', ''); }
    };
    new MutationObserver(function () { if (desk.matches && rail.hasAttribute('inert')) rail.removeAttribute('inert'); })
      .observe(rail, { attributes: true, attributeFilter: ['inert'] });
    if (desk.addEventListener) desk.addEventListener('change', side);
    side();
  }

  /* R5 (Tiresias, WCAG 2.4.3 / 2.1.2): under Reduce Motion the shared panel script focused its close button while the panel
     was still hidden, so focus never landed and Tab walked out behind the modal. Here: once the panel is open AND visible,
     focus goes inside (retried for a few frames); a Tab that starts outside the open panel is pulled back in. */
  if (rail) {
    var focusables = function () { return [].filter.call(rail.querySelectorAll('button,a[href],input:not([type="hidden"]),select,textarea,summary,[tabindex]:not([tabindex="-1"])'), function (x) { return !x.disabled && x.getClientRects().length && getComputedStyle(x).visibility !== 'hidden'; }); };
    var inside = function () { var t = 0; (function f() { if (!document.body.classList.contains('tpw-index-open') || desk.matches) return; if (rail.contains(document.activeElement)) return; var l = focusables(); if (l.length && getComputedStyle(rail).visibility !== 'hidden') { l[0].focus(); if (rail.contains(document.activeElement)) return; } if (++t < 30) requestAnimationFrame(f); })(); };
    new MutationObserver(function () { if (document.body.classList.contains('tpw-index-open')) inside(); }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var back = false;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') back = e.shiftKey;
      if (e.key !== 'Tab' || desk.matches || !document.body.classList.contains('tpw-index-open') || rail.contains(document.activeElement)) return;
      var l = focusables(); if (!l.length) return;
      e.preventDefault(); (e.shiftKey ? l[l.length - 1] : l[0]).focus();
    }, true);
    /* the guard: while the phone panel is open, focus that lands outside it (Tab past the last control, in any browser's Tab
       model) goes straight back in: the first control, or the last on Shift+Tab */
    document.addEventListener('focusin', function (e) {
      if (desk.matches || !document.body.classList.contains('tpw-index-open') || rail.contains(e.target)) return;
      var l = focusables(); if (!l.length) return;
      (back ? l[l.length - 1] : l[0]).focus();
    }, true);
  }

  /* 4: the hand-picked shelf sits INSIDE the grid as one full row after row 2 (phone: after card 6). Shown only with no
     type filter on, a grid longer than that, and none of its products already in rows 1-2. Idempotent: the grid observer
     calls it after every render. */
  var feat = root.querySelector('[data-lu-feat]');
  var li = null;
  var mq = ['(min-width: 768px)', '(min-width: 1025px)', '(min-width: 1280px)'].map(function (q) { return matchMedia(q); });
  function place() {
    if (!feat) return;
    var list = document.querySelector('#ProductGridContainer .collection-product-list');
    var items = list ? list.querySelectorAll(':scope > li.collection-product-list-item') : [];
    var n = 6;
    if (!phone.matches && list) n = 2 * (getComputedStyle(list).gridTemplateColumns.split(' ').filter(Boolean).length || 4);
    /* the in-grid starter kit owns the row-2 slot: a shelf then goes after row 4, never stacked on the kit */
    if (list && list.querySelector(':scope > li.lu-kit')) n = phone.matches ? 8 : 2 * n;
    var on = items.length > n && !(key && sp().getAll(key).length);
    if (on) {
      var hs = {};
      [].forEach.call(feat.querySelectorAll('[data-lu-h]'), function (f) { hs[f.getAttribute('data-lu-h')] = 1; });
      for (var i = 0; i < n && on; i++) { var a = items[i].querySelector('[data-product]'); if (a && hs[a.getAttribute('data-product')]) on = false; }
    }
    if (!on) { if (li && li.parentNode) li.parentNode.removeChild(li); return; }
    if (!li) { li = document.createElement('li'); li.className = 'lu-fli'; }
    if (feat.parentNode !== li) li.appendChild(feat);
    feat.hidden = false;
    var at = items[n - 1];
    if (at.nextElementSibling !== li) at.parentNode.insertBefore(li, at.nextElementSibling);
  }
  var gridEl = document.getElementById('ProductGridContainer');
  var queued = 0;
  function later() { if (!queued) queued = requestAnimationFrame(function () { queued = 0; place(); }); }
  if (feat && gridEl) new MutationObserver(later).observe(gridEl, { childList: true, subtree: true });
  mq.concat(phone).forEach(function (m) { if (m.addEventListener) m.addEventListener('change', later); });
  window.addEventListener('popstate', later);
  place();

  var hdrMin = 0;
  function header(atY) {
    var h = document.querySelector('sticky-header');
    if (!h) return 0;
    var p = getComputedStyle(h).position, r = h.getBoundingClientRect();
    if (!((p === 'fixed' || p === 'sticky') && r.top <= 1 && r.bottom > 0)) return 0;
    var b = Math.round(r.bottom), c = document.querySelector('.shopify-section-header .header.tps-hdr--condensed');
    if (c) { hdrMin = b; return b; }
    return atY != null && atY >= 64 && p === 'fixed' && desk.matches ? (hdrMin || b - 82) : b;
  }
  function stickTop() { if (wrap) wrap.style.setProperty('--lu-top', (phone.matches ? header() : 0) + 'px'); }
  stickTop();
  addEventListener('resize', stickTop, { passive: true });

  /* 5 */
  var ss = document.querySelector('.tps-lu .facet-sort-select[data-lu-default]');
  if (ss) {
    var cur = ss.querySelector('.facet-sort-select__current'), inp = ss.querySelector('.facet-sort-select__input');
    var def = ss.getAttribute('data-lu-default'), lab = ss.getAttribute('data-lu-label') || 'Sort';
    var fix = function () { if (cur && inp && inp.value === def && cur.textContent.trim() !== lab) cur.textContent = lab; };
    if (cur) new MutationObserver(fix).observe(cur, { childList: true, characterData: true, subtree: true });
    fix();
  }

  /* F7: Style group = "Type" with the tile words; chips use the same words */
  var words = { Cube: 'Cubes', Finger: 'Fingers' };   /* Midas R4: the same words as the charcoal tiles on pages without tiles (New) */
  tiles.forEach(function (t) { var v = t.getAttribute('data-lu-v'), b = t.querySelector('b'); if (v && b && key === 'filter.p.m.custom.style') words[v] = b.textContent.trim(); });
  function say(v) { return words[v] || v; }
  function relabel() {
    if (!rail) return;
    var g = rail.querySelector('input[name="filter.p.m.custom.style"]');
    g = g && g.closest('.js-filter');
    if (!g) return;
    var t = g.querySelector('.tpw-fmod-label'); if (t && t.textContent !== 'Type') t.textContent = 'Type';
    var cv = g.querySelector('.tpw-fmod-value'), cw = cv && cv.textContent.trim(); if (cv && words[cw] && words[cw] !== cw) cv.textContent = words[cw];   /* set only on change: an observer loop otherwise */
    [].forEach.call(g.querySelectorAll('input[name="filter.p.m.custom.style"]'), function (i) {
      var l = g.querySelector('label[for="' + i.id + '"] .h5'); if (l && l.textContent !== say(i.value)) l.textContent = say(i.value);
    });
  }
  if (rail) new MutationObserver(relabel).observe(rail, { childList: true, subtree: true });

  /* ARG-F-03 (19 Oct): typing a price in the desktop rail turns on the "1 ACTIVE" row ABOVE the field (53px). Chrome keeps the
     field still with scroll anchoring; Safari has none, so the field jumped down mid-typing. Same result everywhere: while a
     rail text/number field has focus, any change above it is answered with one instant scroll that puts the field back. */
  var pin = null;
  function pinField(e) { var i = e.target; if (i && i.matches && i.matches('#TpwIndexPanel input[type="number"],#TpwIndexPanel input[type="text"]')) pin = { el: i, top: i.getBoundingClientRect().top }; }
  /* Hermes H-G-01 (phone/tablet panel): the panel scrolls on its own, so the same correction goes to the panel's scroll box,
     and the field is then kept clear of the panel's sticky footer */
  function box(el) { for (var n = el.parentElement; n && n !== rail.parentElement; n = n.parentElement) { var o = getComputedStyle(n).overflowY; if ((o === 'auto' || o === 'scroll') && n.scrollHeight > n.clientHeight) return n; } return null; }
  document.addEventListener('focusin', pinField, true);
  document.addEventListener('input', pinField, true);
  document.addEventListener('focusout', function (e) { if (pin && e.target === pin.el) setTimeout(function () { if (pin && document.activeElement !== pin.el) pin = null; }, 0); }, true);
  if (rail) new MutationObserver(function () {
    if (!pin) return;
    var a = document.activeElement, el = a && a.matches && a.matches('#TpwIndexPanel input') ? a : pin.el;
    if (!el.isConnected) { pin = null; return; }
    var d = el.getBoundingClientRect().top - pin.top;
    if (desk.matches) {
      if (Math.abs(d) > 2) { var h = document.documentElement, sb = h.style.scrollBehavior; h.style.scrollBehavior = 'auto'; scrollTo(scrollX, scrollY + d); h.style.scrollBehavior = sb; }
    } else {
      var sc = box(el);
      if (sc) {
        if (Math.abs(d) > 2) sc.scrollTop += d;
        var ft = rail.querySelector('.tpw-panel-foot'), fr = ft && ft.getBoundingClientRect(), er = el.getBoundingClientRect();
        if (fr && fr.height > 0 && er.bottom > fr.top - 8) sc.scrollTop += er.bottom - (fr.top - 8);
      }
    }
    pin.el = el; pin.top = el.getBoundingClientRect().top;
  }).observe(rail, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
  relabel();

  /* 6 */
  var X = '<svg class="lu-x" viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var host = document.querySelector('.tps-lu [data-tpw-gridchips]');
  var head = host && host.closest('.tpw-gridhead');
  function chips() {
    if (!host) return;
    var on = host.querySelectorAll('a.active-facets__button:not(.active-facets__button-remove)');
    if (head) head.classList.toggle('lu-on', on.length > 0);
    [].forEach.call(on, function (a) {
      if (a.hasAttribute('data-lu')) return;
      a.setAttribute('data-lu', '');
      a.removeAttribute('tabindex');
      var s0 = a.querySelector('.active-facets__button-inner > span') || a, w = s0.textContent.replace(/\s+/g, ' ').replace(/(\d)to /, '$1 to ').trim();
      if (s0.textContent !== w) s0.textContent = w;
      if (words[w] && words[w] !== w) s0.textContent = w = words[w];
      a.setAttribute('aria-label', 'Remove ' + w);
      a.insertAdjacentHTML('beforeend', X);
    });
    [].forEach.call(host.querySelectorAll('a.active-facets__button-remove'), function (a) {
      if (a.hasAttribute('data-lu')) return;
      a.setAttribute('data-lu', '');
      a.removeAttribute('tabindex');
      a.setAttribute('aria-label', 'Clear all filters');
      var s = a.querySelector('span'); if (s) s.textContent = 'Clear all';
      var f = a.closest('facet-remove'); if (f) f.classList.add('lu-clr');
    });
  }
  if (host) new MutationObserver(chips).observe(host, { childList: true, subtree: true });
  chips();

  /* 7 (founder 19 Oct: "scroll down as instant so they see blur loading rather than waiting blind"). A user filter change
     starts the scroll ON THE TAP, to the same landing spot (grid head flush under the header / phone bar). While facets.js
     fetches, the old grid shows blurred (CSS on .collection.loading, assets/tps-lineup.css) and the grid is aria-busy. When
     the new grid lands (the A-B-02 done signal above) it is already in view: at most ONE instant correction if the grid head
     moved, then focus to the count. A job = one user change: landed (scroll finished) + rendered (grid swapped). */
  var job = null;
  function begin() {
    var gb = document.getElementById('ProductGridContainer');
    if (gb) gb.setAttribute('aria-busy', 'true');
    if (job) { job.rendered = false; clearTimeout(job.cap); job.cap = setTimeout(end, 20000); return; }   // a second change mid-flight: keep the scroll, wait for the newest grid
    job = { landed: false, rendered: false, focus: true, cap: setTimeout(end, 20000) };
    var t0 = Date.now();
    (function go() {
      if (!job) return;
      if (document.body.classList.contains('tpw-index-open')) { if (Date.now() - t0 < 60000) return setTimeout(go, 250); return end(); }   // phone panel: travel after it closes
      requestAnimationFrame(travel);
    })();
  }
  function end() {
    if (job) clearTimeout(job.cap);
    job = null;
    var gb = document.getElementById('ProductGridContainer');
    if (gb) gb.removeAttribute('aria-busy');
  }
  function target() {
    var col = document.querySelector('.tps-lu .tpw-grid-col');
    if (!col) return null;
    var pad = parseFloat(getComputedStyle(col).paddingTop) || 0;   /* the grid head: column top + its own top padding (A-B-03, F5) */
    var y = scrollY + col.getBoundingClientRect().top + pad;
    return Math.max(0, Math.round(y - header(y - header())));
  }
  function travel() {
    if (!job) return;
    var a = document.activeElement, to = target();
    if (to == null || (a && a.matches && a.matches('input[type="text"],input[type="number"],input[type="search"]'))) { job.focus = false; job.landed = true; return finish(); }   // typing a price: never move the page
    var top = to - scrollY;
    if (top >= -2 && top <= 120) { job.landed = true; return finish(); }
    var smooth = !reduced.matches;
    scrollTo({ top: to, behavior: smooth ? 'smooth' : 'auto' });
    var last = -1, still = 0, n = 0;
    (function wait() {
      if (!job) return;
      if (++n > 120) { job.landed = true; return finish(); }
      if (Math.abs(scrollY - last) < 1) still++; else still = 0;
      last = scrollY;
      if (still < 4 && smooth) return requestAnimationFrame(wait);
      setTimeout(function () { if (job) { job.landed = true; finish(); } }, 380);   // the condensed header settles in ~380 ms
    })();
  }
  function finish() {
    if (!job || !job.landed || !job.rendered) return;
    var to = target();
    if (job.focus && to != null && Math.abs(to - scrollY) > 3) scrollTo({ top: to, behavior: 'auto' });   // one instant correction at most (never while typing a price)
    var f = job.focus;
    end();
    if (f) focusCount();
  }
  function focusCount() {
    var c = document.querySelector('.tps-lu .tpw-gridhead__count');
    if (!c) return;
    if (!c.hasAttribute('tabindex')) c.setAttribute('tabindex', '-1');
    try { c.focus({ preventScroll: true }); } catch (e) {}
  }
})();
